import { RoundButtonsContainer } from "@/components/tools/RoundButtonsContainer";
import { RoundButtonWithIcon } from "@/components/tools/RoundButtonWithIcon";
import { TrashButton } from "@/components/tools/TrashButton";
import { PencilIcon } from "@heroicons/react/24/solid";
import { useEstateContext } from "@/context/EstateContext";
import { useLanguage } from "@/context/LanguageContext";

export function SinglePortfolioActionButtons({
  showTitle = true,
}: {
  showTitle?: boolean;
}) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      selectedProperty: "Vybraná nemovitost",
      editProperty: "Upravit nemovitost",
      deleteProperty: "Smazat nemovitost",
      deletePropertyTitle: "Opravdu chcete smazat nemovitost?",
      deletePropertyDescription:
        "Tuto akci nelze vrátit zpět. Nemovitost bude trvale odstraněna.",
    },
    en: {
      selectedProperty: "Selected property",
      editProperty: "Edit property",
      deleteProperty: "Delete property",
      deletePropertyTitle: "Do you really want to delete this property?",
      deletePropertyDescription:
        "This action cannot be undone. The property will be permanently deleted.",
    },
  }[language];

  const { deleteEstate, openEditModal } = useEstateContext();

  const actions = (
    <RoundButtonsContainer>
      <RoundButtonWithIcon
        icon={PencilIcon}
        text={copy.editProperty}
        onClick={openEditModal}
      />
      <TrashButton
        label={copy.deleteProperty}
        confirmTitle={copy.deletePropertyTitle}
        confirmDescription={copy.deletePropertyDescription}
        onClick={deleteEstate}
      />
    </RoundButtonsContainer>
  );

  if (!showTitle) return actions;

  return (
    <div className="flex items-center justify-between gap-4 px-5 py-3 sm:px-6">
      <p className="app-section-eyebrow">{copy.selectedProperty}</p>
      {actions}
    </div>
  );
}
